// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-menu-container{
.text-truncate {
    white-space: nowrap;       /* Prevent text from wrapping to the next line */
    overflow: hidden;          /* Hide any overflowing content */
    text-overflow: ellipsis;   /* Display "..." for truncated content */
    width: 78%;              /* Set a fixed width */
    display: inline-block;     /* Ensure proper behavior for inline elements */
    vertical-align: middle;    /* Align content vertically */
  }
  .server-online{
    color: green;
    width: 10px;
    height: 10px;
    margin-top: -12%;
    padding-bottom: 5px;
  }
  .server-offline{
    color: red;
    width: 10px;
    height: 10px;
    margin-top: -12%;
    padding-bottom: 5px;
  }
  .active{
    color: white;
  }
  .refresh-icon{
    margin-top: 0%;
        font-size: 2.4rem;
  }
  .create-new-button{
    margin:10px 23px 5px 15px;
  }
}
.create-dataset-modal-cotainer{
  .modal-box-container {
    width: 60%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: white;
    padding: 16px;
    box-shadow: 24px 24px 24px rgba(0, 0, 0, 0.2);
    max-height: 90%;
    overflow-y: auto;
}

.styled-input {
    width: 90%;
    font-family: var(--font-family);
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    padding: 8px 12px;
    border-radius: 8px;
    color: var(--input-text-color, #1a1a1a);
    background: var(--input-bg-color, #fff);
    border: 1px solid var(--input-border-color, #ddd);
    box-shadow: 0 2px 2px var(--input-shadow-color, #f2f2f2);
    transition: border-color 0.2s, box-shadow 0.2s;
    height: 39px;
}

.styled-text-area {
    resize: none;
    height: 90px;
}

.styled-input:hover {
    border-color: #1e88e5;
    /* Blue */
}

.styled-input:focus {
    outline: none;
    border-color: #1e88e5;
    box-shadow: 0 0 0 3px rgba(30, 136, 229, 0.3);
    /* Light blue glow */
}

.modal-labels {
    width: 45%;
}

.input-fields-box {
    width: 48%;
    float: left;
}

.text-area-input-fields-box {
    width: 100%;
    margin-left: 1%;
    float: left;
}



.error-message-container {
    position: fixed; /* or absolute */
    top: 10px; /* Adjust as needed */
    left: 50%;
    transform: translateX(-50%);
    z-index: 9999; /* Ensure it's on top */
    padding: 10px 20px;
    border-radius: 5px;
}

.alert-message {
    display: inline-block;
    font-size: 14px;
    font-weight: bold;
    padding: 9px 41px;
    border-radius: 5px;
}

.error-message {
    background-color: #fee2e2;
    color: #b91c1c;
}

.success-message {

    background-color: #d1fae5;
    color: #047857;
}

.info-message {
     background-color: #bfdbfe;
    color: #1d4ed8;
}


.submit-button-container {
    width: 100%;
    float: inline-end;
    text-align: center;
    margin-top: 2%;
}

.modal-close-button {
    margin-top: -2rem;
    font-size: 1.5rem;
    margin-right: -0.6rem;
    color: black;
    cursor: pointer;
}

/* .close-task-modal-button{
    font-size: 1.4rem;
    margin-right: -2rem;
    margin-top: -2rem;
    color: black;
  } */
.input-fields-container{
  display: flex;
          flex-direction: row;
          margin-bottom: 2vh;
          width: 100%;
          align-items: anchor-center;
}

.modal-title{
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 1vh;
}
.form-input-fields {
  width: 80%;
  border-radius: 5px;
  padding: 8px 12px;
  border: 1px solid #ccc;
  outline: none;
  transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

.form-input-fields:hover {
  border-color: #3498db;
}

.form-input-fields:focus {
  border-color: #2980b9;
  box-shadow: 0 0 5px rgba(52, 152, 219, 0.5);
}

.input-labels {
  width: 20%;
  font-weight: 600;
  color: #333;
  display: inline-block;
  text-align: left;
  padding: 5px 0;
}

.submit-button {
  width: 80%;
  background: #3498db;
  border: none;
  border-radius: 5px;
  color: white;
  padding: 10px 20px;
  cursor: pointer;
  transition: background 0.2s ease-in-out;
}

.submit-button:hover {
  background: #2980b9;
}
.upload-file-input {
  width: 80%;
  border-radius: 5px;
  padding: 8px 12px;
  border: 1px solid #ccc;
  outline: none;
  background-color: #fff;
  cursor: pointer;
  transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

/* Hover effect */
.upload-file-input:hover {
  border-color: #3498db;
}

/* Focus effect */
.upload-file-input:focus {
  border-color: #3498db;
  box-shadow: 0 0 5px rgba(52, 152, 219, 0.5);
}

/* Disabled state */
.upload-file-input:disabled {
  background-color: #f2f2f2;
  cursor: not-allowed;
}

}`, "",{"version":3,"sources":["webpack://./src/assets/styles/searchmenu.css"],"names":[],"mappings":"AAAA;AACA;IACI,mBAAmB,QAAQ,gDAAgD;IAC3E,gBAAgB,WAAW,iCAAiC;IAC5D,uBAAuB,IAAI,wCAAwC;IACnE,UAAU,eAAe,sBAAsB;IAC/C,qBAAqB,MAAM,+CAA+C;IAC1E,sBAAsB,KAAK,6BAA6B;EAC1D;EACA;IACE,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;QACV,iBAAiB;EACvB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,UAAU;IACV,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,uBAAuB;IACvB,aAAa;IACb,6CAA6C;IAC7C,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,+BAA+B;IAC/B,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,uCAAuC;IACvC,uCAAuC;IACvC,iDAAiD;IACjD,wDAAwD;IACxD,8CAA8C;IAC9C,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;IAC7C,oBAAoB;AACxB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;IACf,WAAW;AACf;;;;AAIA;IACI,eAAe,EAAE,gBAAgB;IACjC,SAAS,EAAE,qBAAqB;IAChC,SAAS;IACT,2BAA2B;IAC3B,aAAa,EAAE,uBAAuB;IACtC,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;;IAEI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;KACK,yBAAyB;IAC1B,cAAc;AAClB;;;AAGA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;IACZ,eAAe;AACnB;;AAEA;;;;;KAKK;AACL;EACE,aAAa;UACL,mBAAmB;UACnB,kBAAkB;UAClB,WAAW;UACX,0BAA0B;AACpC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,sEAAsE;AACxE;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,sEAAsE;AACxE;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA","sourcesContent":[".search-menu-container{\n.text-truncate {\n    white-space: nowrap;       /* Prevent text from wrapping to the next line */\n    overflow: hidden;          /* Hide any overflowing content */\n    text-overflow: ellipsis;   /* Display \"...\" for truncated content */\n    width: 78%;              /* Set a fixed width */\n    display: inline-block;     /* Ensure proper behavior for inline elements */\n    vertical-align: middle;    /* Align content vertically */\n  }\n  .server-online{\n    color: green;\n    width: 10px;\n    height: 10px;\n    margin-top: -12%;\n    padding-bottom: 5px;\n  }\n  .server-offline{\n    color: red;\n    width: 10px;\n    height: 10px;\n    margin-top: -12%;\n    padding-bottom: 5px;\n  }\n  .active{\n    color: white;\n  }\n  .refresh-icon{\n    margin-top: 0%;\n        font-size: 2.4rem;\n  }\n  .create-new-button{\n    margin:10px 23px 5px 15px;\n  }\n}\n.create-dataset-modal-cotainer{\n  .modal-box-container {\n    width: 60%;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background-color: white;\n    padding: 16px;\n    box-shadow: 24px 24px 24px rgba(0, 0, 0, 0.2);\n    max-height: 90%;\n    overflow-y: auto;\n}\n\n.styled-input {\n    width: 90%;\n    font-family: var(--font-family);\n    font-size: 0.875rem;\n    font-weight: 400;\n    line-height: 1.5;\n    padding: 8px 12px;\n    border-radius: 8px;\n    color: var(--input-text-color, #1a1a1a);\n    background: var(--input-bg-color, #fff);\n    border: 1px solid var(--input-border-color, #ddd);\n    box-shadow: 0 2px 2px var(--input-shadow-color, #f2f2f2);\n    transition: border-color 0.2s, box-shadow 0.2s;\n    height: 39px;\n}\n\n.styled-text-area {\n    resize: none;\n    height: 90px;\n}\n\n.styled-input:hover {\n    border-color: #1e88e5;\n    /* Blue */\n}\n\n.styled-input:focus {\n    outline: none;\n    border-color: #1e88e5;\n    box-shadow: 0 0 0 3px rgba(30, 136, 229, 0.3);\n    /* Light blue glow */\n}\n\n.modal-labels {\n    width: 45%;\n}\n\n.input-fields-box {\n    width: 48%;\n    float: left;\n}\n\n.text-area-input-fields-box {\n    width: 100%;\n    margin-left: 1%;\n    float: left;\n}\n\n\n\n.error-message-container {\n    position: fixed; /* or absolute */\n    top: 10px; /* Adjust as needed */\n    left: 50%;\n    transform: translateX(-50%);\n    z-index: 9999; /* Ensure it's on top */\n    padding: 10px 20px;\n    border-radius: 5px;\n}\n\n.alert-message {\n    display: inline-block;\n    font-size: 14px;\n    font-weight: bold;\n    padding: 9px 41px;\n    border-radius: 5px;\n}\n\n.error-message {\n    background-color: #fee2e2;\n    color: #b91c1c;\n}\n\n.success-message {\n\n    background-color: #d1fae5;\n    color: #047857;\n}\n\n.info-message {\n     background-color: #bfdbfe;\n    color: #1d4ed8;\n}\n\n\n.submit-button-container {\n    width: 100%;\n    float: inline-end;\n    text-align: center;\n    margin-top: 2%;\n}\n\n.modal-close-button {\n    margin-top: -2rem;\n    font-size: 1.5rem;\n    margin-right: -0.6rem;\n    color: black;\n    cursor: pointer;\n}\n\n/* .close-task-modal-button{\n    font-size: 1.4rem;\n    margin-right: -2rem;\n    margin-top: -2rem;\n    color: black;\n  } */\n.input-fields-container{\n  display: flex;\n          flex-direction: row;\n          margin-bottom: 2vh;\n          width: 100%;\n          align-items: anchor-center;\n}\n\n.modal-title{\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 1vh;\n}\n.form-input-fields {\n  width: 80%;\n  border-radius: 5px;\n  padding: 8px 12px;\n  border: 1px solid #ccc;\n  outline: none;\n  transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;\n}\n\n.form-input-fields:hover {\n  border-color: #3498db;\n}\n\n.form-input-fields:focus {\n  border-color: #2980b9;\n  box-shadow: 0 0 5px rgba(52, 152, 219, 0.5);\n}\n\n.input-labels {\n  width: 20%;\n  font-weight: 600;\n  color: #333;\n  display: inline-block;\n  text-align: left;\n  padding: 5px 0;\n}\n\n.submit-button {\n  width: 80%;\n  background: #3498db;\n  border: none;\n  border-radius: 5px;\n  color: white;\n  padding: 10px 20px;\n  cursor: pointer;\n  transition: background 0.2s ease-in-out;\n}\n\n.submit-button:hover {\n  background: #2980b9;\n}\n.upload-file-input {\n  width: 80%;\n  border-radius: 5px;\n  padding: 8px 12px;\n  border: 1px solid #ccc;\n  outline: none;\n  background-color: #fff;\n  cursor: pointer;\n  transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;\n}\n\n/* Hover effect */\n.upload-file-input:hover {\n  border-color: #3498db;\n}\n\n/* Focus effect */\n.upload-file-input:focus {\n  border-color: #3498db;\n  box-shadow: 0 0 5px rgba(52, 152, 219, 0.5);\n}\n\n/* Disabled state */\n.upload-file-input:disabled {\n  background-color: #f2f2f2;\n  cursor: not-allowed;\n}\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
